import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Em produção sem variáveis configuradas, criar cliente dummy que não quebra o app
let supabaseClient;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('⚠️ Supabase env vars not configured - auth features disabled');
  // Cliente dummy para não quebrar o app
  supabaseClient = createClient(
    'https://placeholder.supabase.co', 
    'placeholder-anon-key'
  );
} else {
  supabaseClient = createClient(supabaseUrl, supabaseAnonKey);
}

export const supabase = supabaseClient;
